import * as tslib_1 from "tslib";
import { BaseApiClient } from './BaseApiClient';
export var TRACKS_ENDPOINTS = {
    ALL: '/Tracks',
};
/**
 * TracksApiClient - client for fetching tracks BFF endpoints
 * @export
 * @class TracksApiClient
 * @extends {BaseApiClient}
 */
var TracksApiClient = /** @class */ (function (_super) {
    tslib_1.__extends(TracksApiClient, _super);
    function TracksApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetch all tracks from BFF
     * @throws {RequiredError}
     * @memberof TracksApiClient
     */
    TracksApiClient.prototype.getTracks = function () {
        var fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(TRACKS_ENDPOINTS.ALL, fetchOptions);
    };
    return TracksApiClient;
}(BaseApiClient));
export { TracksApiClient };
//# sourceMappingURL=TracksApiClient.js.map